/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DuplicateOverwolfMapperItem } from './DuplicateOverwolfMapperItem';
import {
    DuplicateOverwolfMapperItemFromJSON,
    DuplicateOverwolfMapperItemFromJSONTyped,
    DuplicateOverwolfMapperItemToJSON,
    DuplicateOverwolfMapperItemToJSONTyped,
} from './DuplicateOverwolfMapperItem';

/**
 * 
 * @export
 * @interface DuplicateOverwolfDataMappersResponse
 */
export interface DuplicateOverwolfDataMappersResponse {
    /**
     * Whether this was a dry run
     * @type {boolean}
     * @memberof DuplicateOverwolfDataMappersResponse
     */
    dryRun: boolean;
    /**
     * Number of data mappers duplicated (or would be duplicated)
     * @type {number}
     * @memberof DuplicateOverwolfDataMappersResponse
     */
    duplicatedCount: number;
    /**
     * List of mappers that were/would be duplicated
     * @type {Array<DuplicateOverwolfMapperItem>}
     * @memberof DuplicateOverwolfDataMappersResponse
     */
    mappers: Array<DuplicateOverwolfMapperItem>;
}

/**
 * Check if a given object implements the DuplicateOverwolfDataMappersResponse interface.
 */
export function instanceOfDuplicateOverwolfDataMappersResponse(value: object): value is DuplicateOverwolfDataMappersResponse {
    if (!('dryRun' in value) || value['dryRun'] === undefined) return false;
    if (!('duplicatedCount' in value) || value['duplicatedCount'] === undefined) return false;
    if (!('mappers' in value) || value['mappers'] === undefined) return false;
    return true;
}

export function DuplicateOverwolfDataMappersResponseFromJSON(json: any): DuplicateOverwolfDataMappersResponse {
    return DuplicateOverwolfDataMappersResponseFromJSONTyped(json, false);
}

export function DuplicateOverwolfDataMappersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DuplicateOverwolfDataMappersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'dryRun': json['dryRun'],
        'duplicatedCount': json['duplicatedCount'],
        'mappers': ((json['mappers'] as Array<any>).map(DuplicateOverwolfMapperItemFromJSON)),
    };
}

export function DuplicateOverwolfDataMappersResponseToJSON(json: any): DuplicateOverwolfDataMappersResponse {
    return DuplicateOverwolfDataMappersResponseToJSONTyped(json, false);
}

export function DuplicateOverwolfDataMappersResponseToJSONTyped(value?: DuplicateOverwolfDataMappersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dryRun': value['dryRun'],
        'duplicatedCount': value['duplicatedCount'],
        'mappers': ((value['mappers'] as Array<any>).map(DuplicateOverwolfMapperItemToJSON)),
    };
}

